import { menuItems } from "menu-items";

import { SaaSCoType, GeneralCoType } from "../constants/companyTypes";

export const tableItems = [
  {
    id: "financial-forecast-company-details",
    title: "Company Details",
    companyTypes: [SaaSCoType, GeneralCoType],
    children: [
      {
        id: "A",
        title: "General Assumptions",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "B",
        title: "Time Series Assumptions",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
    ],
  },
  {
    id: "financial-forecast-assumptions",
    title: "Assumptions",
    companyTypes: [SaaSCoType, GeneralCoType],
    children: [
      {
        id: "A",
        title: "Subscriber Acquisition Assumptions",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "B",
        title: "Net Working Capital",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "C",
        title: "CAPEX",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
    ],
  },
  {
    id: "financial-forecast-subscriber-acquisitions",
    title: "Subscriber Acquisitions",
    companyTypes: [SaaSCoType, GeneralCoType],
    children: [
      {
        id: "A",
        title: "Subscriber Acquisition Assumptions",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "B",
        title: "New Installs",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "C",
        title: "Cumulative Installs",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "D",
        title: "Cumulative Members",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "E",
        title: "Cumulative Subscribers",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
    ],
  },
  {
    id: "financial-forecast-revenue",
    title: "Revenue",
    companyTypes: [SaaSCoType, GeneralCoType],
    children: [
      {
        id: "A",
        title: "Subscription Revenue",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "B",
        title: "Subscription Commissions",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "C",
        title: "Other Revenue",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
    ],
  },
  {
    id: "financial-forecast-cost-and-expenses",
    title: "Cost And Expenses",
    companyTypes: [SaaSCoType, GeneralCoType],
    children: [
      {
        id: "A",
        title: "Cost of Sales",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "B",
        title: "General Administrative Expenses",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "C",
        title: "Sales and Marketing Expenses",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
    ],
  },
  {
    id: "financial-forecast-hiring-plan",
    title: "Hiring Plan",
    companyTypes: [SaaSCoType, GeneralCoType],
    children: [
      {
        id: "A",
        title: "Founders and Partners",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "B",
        title: "Tech & Product Development",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "C",
        title: "Sales and Marketing",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "D",
        title: "Finance & Analytics & Operations",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "E",
        title: "Other",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "F",
        title: "Average",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
    ],
  },
  {
    id: "financial-forecast-profit-loss",
    title: "Profit & Loss",
    companyTypes: [SaaSCoType, GeneralCoType],
    children: [
      {
        id: "A",
        title: "Profit and Loss Main",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
    ],
  },
  {
    id: "financial-forecast-freecash-flow",
    title: "Free Cash Flow",
    companyTypes: [SaaSCoType, GeneralCoType],
    children: [
      {
        id: "A",
        title: "Free Cash Flow",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
    ],
  },
  {
    id: "Customize",
    title: "Customize",
    companyTypes: [SaaSCoType, GeneralCoType],
    children: [
      {
        id: "A",
        title: "Color Palette",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "B",
        title: "Assumption Details",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "C",
        title: "Font Family",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "D",
        title: "Border Radius",
        companyTypes: [SaaSCoType, GeneralCoType],
      },
    ],
  },
  {
    id: "performance-analysis",
    title: "Performance Analysis",
    companyTypes: [SaaSCoType, GeneralCoType],
  },
  {
    id: "calculators-saas-subscription-fee",
    title: "SaaS Subscription Fee Calculator",
    companyTypes: [SaaSCoType, GeneralCoType],
  },
  {
    id: "calculators-emergency-fund",
    title: "Emergency Fund Calculator",
    companyTypes: [SaaSCoType, GeneralCoType],
  },
  {
    id: "calculators-cash-runway",
    title: "Cash Runway Calculator",
    companyTypes: [SaaSCoType, GeneralCoType],
  },
];

const canViewItem = (item, companyType) => {
  if (!item?.companyTypes || item.companyTypes.length === 0) {
    return true;
  }

  if (!companyType) {
    return true;
  }

  return item.companyTypes.includes(companyType);
};

export const tableAccess = (pageId, cardId, authState) => {
  const companyType = authState?.company?.Type;
  const mainPage = tableItems.find(
    (menuItem) => menuItem.id === pageId && canViewItem(menuItem, companyType)
  );

  if (!mainPage) {
    return null;
  }

  if (cardId) {
    const childCard = mainPage.children?.find(
      (child) => child.id === cardId && canViewItem(child, companyType)
    );

    return childCard ? { ...mainPage, children: [childCard] } : null;
  }
  
  const accessibleChildren = mainPage.children?.filter((child) =>
    canViewItem(child, companyType)
  );

  return { ...mainPage, children: accessibleChildren };
};

export const filterMenuItems = (authState) => {
  const userRole = authState?.user?.Role;
  const companyType = authState?.company?.Type;

  const isRoleAllowed = (item) =>
    !item.allowedRoles || (userRole && item.allowedRoles.includes(userRole));

  return menuItems
    .map((menuItem) => {
      const typeAllowed =
        !menuItem.companyTypes ||
        !companyType ||
        menuItem.companyTypes.includes(companyType);
      const roleAllowed = isRoleAllowed(menuItem);

      if (!typeAllowed || !roleAllowed) {
        return null;
      }

      // Handle dynamic titles at the top level
      const title = menuItem.titles
        ? menuItem.titles[companyType] || menuItem.title
        : menuItem.title;

      if (menuItem.children) {
        const filteredChildren = menuItem.children
          .filter(
            (child) =>
              (!child.companyTypes ||
                !companyType ||
                child.companyTypes.includes(companyType)) &&
              isRoleAllowed(child)
          )
          .map((child) => {
            // Handle dynamic titles for children
            const childTitle = child.titles
              ? child.titles[companyType] || child.title
              : child.title;

            return {
              ...child,
              title: childTitle,
            };
          });

        if (filteredChildren.length > 0) {
          return {
            ...menuItem,
            title,
            children: filteredChildren,
          };
        } else {
          return null;
        }
      }

      return {
        ...menuItem,
        title,
      };
    })
    .filter(Boolean);
};
